module.exports = __webpack_public_path__ + "static/media/musicEndframe.175cd608.png";